import React from 'react';
import AdminLayout from '../../components/admin/AdminLayout';
import BookingsList from '../../components/admin/BookingsList';

const Bookings = () => {
  return (
    <AdminLayout>
      <BookingsList />
    </AdminLayout>
  );
};

export default Bookings;
